"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.action = exports.init = exports.isLocal = void 0;
exports.isLocal = window.location.href.includes('localhost:');
var namespace = 'ga-event';
var _category = 'default';
function init(category) {
    _category = category;
    action('init', 'init');
}
exports.init = init;
function action(eventType, label, isInteraction) {
    if (isInteraction === void 0) { isInteraction = true; }
    var cat = exports.isLocal ? 'local-' + _category : _category;
    //let lab = cat + '/' + label
    console.log(namespace, 'screen-view', label);
    _gtag(eventType, label, isInteraction);
    // _gtag('screen_view', {
    //   screen_name: lab,
    // })
    // https://developers.google.com/gtagjs/reference/event#screen_view
    // gtag('event', 'screen_view', {
    //   screen_name: 'About'
    // });
}
exports.action = action;
function _gtag(eventType, label, isInteraction) {
    if (isInteraction === void 0) { isInteraction = true; }
    if (typeof gtag !== 'undefined') {
        // gtag('event', eventType, data)
        // console.log(namespace, eventType)
        var cat = exports.isLocal ? 'local-' + _category : _category; // + '-' + category2
        if (!isInteraction) {
            gtag('event', eventType, {
                event_category: cat,
                event_label: label,
                non_interaction: true,
            });
        }
        else {
            gtag('event', eventType, {
                event_category: cat,
                event_label: label,
            });
        }
        var location_1 = '/';
        if (exports.isLocal) {
            location_1 += 'local/';
        }
        location_1 += 'app/';
        location_1 += _category + '/';
        location_1 += eventType + '/';
        location_1 += label;
        gtag('event', 'page_view', {
            page_location: location_1,
        });
    }
    else {
        console.log(namespace, 'analytics not init', eventType);
    }
}
